import { createContext, useContext, useState, useEffect } from "react";
import PropTypes from "prop-types";

/**
 * Context for managing breadcrumb navigation
 */
const BreadcrumbContext = createContext();

/**
 * Hook to access breadcrumb context
 * @returns {Object} Breadcrumb context value with breadcrumbs array and setBreadcrumbs function
 */
export function useBreadcrumb() {
  const context = useContext(BreadcrumbContext);
  if (!context) {
    throw new Error("useBreadcrumb must be used within a BreadcrumbProvider");
  }
  return context;
}

/**
 * Provider component for breadcrumb context
 * @param {Object} props - Component props
 * @param {React.ReactNode} props.children - Child components
 */
export function BreadcrumbProvider({ children }) {
  const [breadcrumbs, setBreadcrumbs] = useState([{ name: "Home", path: "/" }]);

  useEffect(() => {}, [breadcrumbs]);

  return (
    <BreadcrumbContext.Provider value={{ breadcrumbs, setBreadcrumbs }}>
      {children}
    </BreadcrumbContext.Provider>
  );
}

BreadcrumbProvider.propTypes = {
  children: PropTypes.node.isRequired,
};

export default BreadcrumbContext;
